export default __webpack_public_path__ + "/dist/images/no-data.svg";